import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function EmergencyResponseCenter() {
  return <section data-section-id="222249" id="emergency-response-center" className="dark relative flex min-h-screen w-full items-center overflow-hidden bg-[#0b1221]">
      {}
      <div className="absolute inset-0 bg-[url(https://wpvc-images.s3.us-east-1.amazonaws.com/images/1689786/img/metropolitan_topographic_map.png)] bg-cover bg-center bg-no-repeat bg-fixed opacity-20" aria-hidden="true" />
      
      {}
      <div className="absolute inset-0 bg-[#0b1221]/60 transition-opacity duration-1000" aria-hidden="true" />

      {}
      <div className="container relative z-10 mx-auto w-full px-4 md:px-8">
        <div className="grid grid-cols-12 gap-4">
          {}
          <div className="col-span-12 flex flex-col items-start gap-8 md:col-span-8 md:col-start-2 lg:col-span-6">
            
            <h1 className="font-default text-5xl font-extrabold leading-[1.1] tracking-tighter text-white drop-shadow-[0_0_15px_rgba(239,68,68,0.5)] md:text-6xl lg:text-8xl">
              EMERGENCY: CALL 911
            </h1>
            
            <p className="max-w-md font-sans text-lg font-medium leading-relaxed text-white/90 md:text-xl">
              For non-emergencies, call (555) 010-9000. Metropolitan Central Police is standing by to serve and protect our community.
            </p>
            
            <Link to="/PublicServicesPage" className="mt-4">
              <Button variant="outline" className="rounded-md border-2 border-white bg-transparent px-8 py-6 text-xs font-bold uppercase tracking-[0.2em] text-white transition-all duration-500 hover:bg-white hover:text-[#0b1221]">
                File a Report
              </Button>
            </Link>
            
          </div>
        </div>
      </div>

      {}
      <div className="absolute bottom-12 right-8 z-10 hidden flex-col items-center gap-6 md:right-12 md:flex">
        <span className="font-mono text-[10px] uppercase tracking-[0.3em] text-white/70" style={{
        writingMode: 'vertical-rl'
      }}>
          Status: Active Patrols
        </span>
        <div className="relative h-24 w-[1px] overflow-hidden bg-white/20">
          <div className="absolute left-0 top-0 h-1/3 w-full animate-pulse bg-[#22c55e]" />
        </div>
      </div>
    </section>;
}